import { ServiceError } from "../../../../../../../service/Shared";
import { ActionButtons, Column, ErrorBox, Modal, Row } from "../../../../../../../widget";
import { useRemoveWorkflowModal } from "./useRemoveWorkflowModal";

interface RemoveWorkflowModalProps {
  show: boolean;
  closeModal: () => void;
}

export const RemoveWorkflowModal = ({ show, closeModal }: RemoveWorkflowModalProps): JSX.Element => {
  const { handleRemoveWorkflow, isHandleRemoveWorkflowLoading, onCancel, errors } = useRemoveWorkflowModal({
    closeModal,
  });

  return (
    <Modal show={show} title="Remove workflow?" onClose={onCancel}>
      {errors && errors.length > 0 && (
        <Row spacingV="ll">
          <Column offset={3} span={6}>
            <ErrorBox
              title="Please solve the below issues before saving"
              text={errors.map((error: ServiceError) => error.message)}
            />
          </Column>
        </Row>
      )}
      <form onSubmit={(e) => handleRemoveWorkflow(e)}>
        <Row spacingV="ll" justify="center">
          <Column span={10}>
            <p className="body1">
              Deleting this workflow will permanently remove all steps, associated tasks and their progress from the
              workflow. This action cannot be undone.
            </p>
          </Column>
        </Row>
        <Row justify="center">
          <ActionButtons onCancel={onCancel} submitButtonLabel="Save" isLoading={isHandleRemoveWorkflowLoading} />
        </Row>
      </form>
    </Modal>
  );
};
